import type { LogoLoadingProps } from './const';
import { cn } from '@utils';
import { IconLogoText } from '@wegic/icon';
import { forwardRef } from 'react';
import './index.less';

function LogoLoading(props: LogoLoadingProps, ref: React.Ref<HTMLDivElement>) {
  const { className, style } = props;

  return (
    <div ref={ref} className={cn('wg-logo-loading', className)} style={style}>
      <IconLogoText />
      <div className="wg-logo-loading__rect"></div>
    </div>
  );
}

const LogoLoadingComponent = forwardRef<HTMLDivElement, LogoLoadingProps>(LogoLoading);

LogoLoadingComponent.displayName = 'LogoLoading';

export default LogoLoadingComponent;

export type { LogoLoadingProps };
